<div class="toggle-switch-wrapper" [class.label-left]="labelPosition() === 'left'">
  <label *ngIf="label() && labelPosition() === 'left'" [for]="id()" class="toggle-label">{{ label() }}</label>
  <p-toggleswitch
    [inputId]="id()"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [trueValue]="trueValue()"
    [falseValue]="falseValue()"
    (onChange)="handleChange($event)">
  </p-toggleswitch>
  <label *ngIf="label() && labelPosition() === 'right'" [for]="id()" class="toggle-label">{{ label() }}</label>
</div>
